import React, {
  memo, useCallback,
} from 'react';
import noop from 'lodash/noop';
import { useSelector } from 'react-redux';
import Locale from '@active/react-utils/i18n/Locale';
import pubSubInstance from '../../../../../shared/utils/pubSub';
import { handleKeyboardEvent } from '../../../../../shared/utils/commonUtils';

const SyncButton = ({ trackingCallback = noop }) => {
  const {
    renderShippingSuccess,
  } = useSelector(state => state.passPortWidgets || {});
  const {
    widgetNameSpace,
  } = useSelector(state => state.propsData);

  const handleClick = useCallback(() => {
    pubSubInstance.dispatch(`${widgetNameSpace}-get-shipping-address`);
    trackingCallback({ id: 'cui.sync.shipping.address.clicked' });
  }, [ widgetNameSpace, trackingCallback ]);

  if (!renderShippingSuccess) {
    return null;
  }

  return (
    <button
      className='shipping-address__sync-btn link-style'
      onKeyDown={handleKeyboardEvent(handleClick, [ 'Enter' ])}
      onClick={handleClick}>
      <i className="ic-sync cui-mg-r-4"/>
      <Locale id="checkout.lib.components.text.syncWithShippingAddress" />
    </button>
  );
};

export default memo(SyncButton);
